'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { useEffect } from 'react';
import { trackPageView } from '@/utils/analytics';

/**
 * Custom hook to track page views in client components.
 * Particularly useful for client-side routes that don't use SSR
 * or aren't covered by the root layout analytics.
 */
export function usePageViewTracking() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (pathname) {
      // Create the full URL path with search params
      const queryString = searchParams?.toString();
      const fullPath = queryString ? `${pathname}?${queryString}` : pathname;

      // Track the page view
      trackPageView(fullPath);
    }
  }, [pathname, searchParams]);
}
